// extracted by mini-css-extract-plugin
export default {"centeredSlider":"LongBanner_centeredSlider__cuXE3","imageHeight":"LongBanner_imageHeight__xnUCP"};